import Decimal from "decimal.js";
import { isLogin, RequestAsstes } from "../../NetworkFactory";
import { DecimalConvert, FullURL } from "../factory/FactoryUtil";

const COINS = '1';
const FUTURE = '2';
const SECOND_FUTURE = '3';

let listenerObjects = {}
let coinsData = {};
let futureData = {};
let secondFutureData = {};

export const AssetsGetName = (type) => {
    if(type === COINS) {
        return 'Coins'
    }
    else if(type === FUTURE) {
        return 'Future'
    }
    else if(type === SECOND_FUTURE) {
        return 'Second Future'
    }
    return ''
}

export const AssetsGetData = (type) => {
    if(type === COINS) {
        return coinsData || {}
    }
    else if(type === FUTURE) {
        return futureData || {}
    }
    else if(type === SECOND_FUTURE) {
        return secondFutureData || {}
    }
    return {}
}

export const AssetsListener = (type, name, fuc) => {
    let types = listenerObjects[type]
    if(types === undefined) {
        listenerObjects[type] = types = {}
    }
    types[name] = fuc
    InitAssetsData(type)
}

export const AssetsListenerRemove = (type, name) => {
    let types = listenerObjects[type]
    if(types) {
        delete types[name]
    }
    
}

const InitAssetsData = (type) => {
    const data = AssetsGetData(type)
    if(Object.keys(data).length === 0) {
        RquestData(type)
    } else {
        PostListener(type, data)
    }
}

const PostListener = (type, data) => {
    const listeners = listenerObjects[type] || []
    if(listeners) {
        Object.values(listeners).forEach((fuc) => {
            fuc(data);
        });
    }
}

export const RefreshAssets = (type) => {
    RquestData(type)
}

const RquestData = (type) => {
    if (typeof type !== 'string') {
        return
    }
    if(!isLogin()) {
        return
    }
    RequestAsstes(type).then(response => {
        try {
            // # 解析数据并排序
            let data = []
            Object.values(response.data.data || []).forEach(item => {
                data.push({
                    symbol : item.symbol || '',
                    logo : FullURL(item.logo),
                    available : DecimalConvert(item.available),
                    unusable : DecimalConvert(item.unusable),
                    price : DecimalConvert(item.price),
                    equivalent : DecimalConvert(item.equivalent)
                })
            });
            data = [...data].sort((a, b) => {
                return new Decimal(b.equivalent).sub(new Decimal(a.equivalent))
            });

            if(type === COINS) {
                coinsData = {
                    total : DecimalConvert(response.data.total || '0.00'),
                    data : data
                }
                PostListener(type, coinsData)
            } else if(type === FUTURE) {
                futureData = {
                    total : DecimalConvert(response.data.total || '0.00'),
                    data : data
                }
                PostListener(type, futureData)
            } else if(type === SECOND_FUTURE) {
                secondFutureData = {
                    total : DecimalConvert(response.data.total || '0.00'),
                    data : data
                }
                PostListener(type, secondFutureData)
            }
        } catch {
            console.log('error');
        }
    })
}